






























import { defineComponent, ref, computed } from "@vue/composition-api";
import ImagePopup from "@c/organisms/app/ImagePopup.vue";
import ImageModel from "@/ts/models/imageClass";

export default defineComponent({
  name: "MediumImage",

  components: {
    ImagePopup
  },

  props: {
    image: {
      type: Object
    }
  },

  setup(props) {
    var expand_image = ref(false);

    var comp_image = computed(() => {
      if (props.image) {
        return props.image;
      } else {
        return new ImageModel();
      }
    });

    return {
      comp_image,
      expand_image
    };
  }
});
